import React  from "react";
import { ComponentQueryLoader } from "../../../../../shared/component-query-loader";
import { useQuery } from "@apollo/client";
import { CasesSendReportFilePickerCaseListContainerSendReportCaseV1Document } from "../../../../../../generated";
import { useParams } from "react-router-dom";
import { FilePickerCaseList } from "./file-picker-case-list";

interface FilePickerCaseListContainerProps {
    setCaseInfo: (selectedCaseId: string, selectedCaseType: string, isArchived?: boolean) => void;
}

export const FilePickerCaseListContainer: React.FC<
FilePickerCaseListContainerProps
> = (props) => {
    const params = useParams();
    const caseId = params.caseId || "";
    
    const {
        data: applicantIdData,
        loading: applicantIdLoading,
        error: applicantIdError,
      } = useQuery(
        CasesSendReportFilePickerCaseListContainerSendReportCaseV1Document,
        {
          variables: {
            sendReportCaseV1Id: caseId,
          },
        }
      );
    
      const applicantId =
        applicantIdData?.sendReportCaseV1?.applicant?.id;
      const applicantName =
        applicantIdData?.sendReportCaseV1?.applicant?.displayName ?? "";
    

  return (
    <ComponentQueryLoader
      loading={applicantIdLoading}
      error={applicantIdError}
      hasData={true}
      hasDataComponent={<FilePickerCaseList setCaseInfo={props.setCaseInfo} applicantName={applicantName} applicantId={applicantId} />}
    />
  );
};
